import { useRef } from 'react'

import type { ReactElement } from 'react'
import type { IReview } from '~/types/review'

import columns from './columns'

import Modal from '~/components/Modal'
import { ModalBody, ModalHeader } from '~/components/Modal/Layout'
import TableWrapper from '~/components/Tables/TableWrapper'
import { useReviewHistoryQuery } from '~/queries/reviews'

import './styles.scss'

const ENTRIES_NAME = 'review-history'

interface ModalContentProps {
  review: IReview
}

const HistoryModalContent = ({ review }: ModalContentProps): ReactElement => {
  /** Local state */

  const tableRef = useRef<HTMLDivElement>(null)

  /** Queries */

  const { data } = useReviewHistoryQuery({ reviewId: review.id })

  /** Render */

  return (
    <ModalBody className="modal-body">
      <TableWrapper
        className="reviews-history-table"
        columnDefs={columns}
        entriesName={ENTRIES_NAME}
        pagination={false}
        rowData={data}
        rowStyle={{ cursor: 'default' }}
        tableRef={tableRef}
        withPagination={false}
        withSearchBar={false}
      />
    </ModalBody>
  )
}

interface ModalProps {
  isOpen: boolean
  onClose: VoidFunction
  review?: IReview
}

const HistoryModal = ({ isOpen, onClose, review }: ModalProps): ReactElement => {
  return (
    <Modal className="review-history-modal" isOpen={isOpen} onCloseModal={onClose}>
      <ModalHeader>Review history</ModalHeader>
      {review ? <HistoryModalContent review={review} /> : null}
    </Modal>
  )
}

export default HistoryModal
